import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import * as ReactDatetimeClass from "react-datetime";
import * as DTOS from "../../../../FeralScan.dtos";
import ContentContainer from '../../../Content/ContentContainer';
import { withTheme } from '../../../../common/withTheme';
import PlotMetaInfoSelect, { IPlotMetaInfoSelectOption } from '../../../Common/PlotMetaInfoSelect';
import PlotMetaUserInfoSelect from '../../../common/PlotMetaUserInfoSelect';
import PlotSelect, { IPlotSelectOption } from '../../../Common/PlotSelect';
import moment = require('moment');
import Select from "react-select";
import { JsonServiceClient } from '@servicestack/client';

type PageAdminExportPlotsProps = {
    theme?: string;
}

type PageAdminExportPlotsActions = {
}

type PageAdminExportPlotsRouteParams = {
}

type PageAdminExportPlotsQueryParams = {
    plotId?: string;
    apcCode?: string;
    userId?: string;
    surname?: string;
    startDate?: string;
    endDate?: string;
}

type PageAdminExportPlotsPropsMapped = {
    plotLoading: boolean;
    plotMetaInfo: any;
    plots: any;
}

type PageAdminExportPlotsActionsMapped = {  
}

type PageAdminExportPlotsAllPropsInherited = PageAdminExportPlotsProps & PageAdminExportPlotsActions;
type PageAdminExportPlotsAllPropsMapped = PageAdminExportPlotsPropsMapped & PageAdminExportPlotsActionsMapped;

type PageAdminExportPlotsAllProps = IBasePageProps<PageAdminExportPlotsRouteParams, PageAdminExportPlotsQueryParams> & Partial<PageAdminExportPlotsAllPropsMapped> & PageAdminExportPlotsAllPropsInherited;

interface IPageAdminExportsState {
    apcCodeOptionValue: IPlotMetaInfoSelectOption;
    waterBodyOptionValue: IPlotMetaInfoSelectOption;
    plotOptionValue: IPlotSelectOption;
    userIdOptionValue: IPlotSelectOption;
    surnameOptionValue: IPlotMetaInfoSelectOption;
    userPlotOptionValue: IPlotSelectOption;
    selectedUserIds: number[];
    dateOptionValue: { value: any, label: any };

    valueSet: boolean;

    startDate: any;
    endDate: any;
}

const optionsDateRange = [{ label: 'All Data', value: 'ALL' }, { label: 'Custom', value: 'CUSTOM' }]

class PageAdminExportPlots extends React.Component<PageAdminExportPlotsAllProps, IPageAdminExportsState> {

    constructor(props, context) {
        super(props, context);

        this.state = {
            apcCodeOptionValue: null,
            waterBodyOptionValue: null,
            plotOptionValue: null,
            userIdOptionValue: null,
            surnameOptionValue: null,
            userPlotOptionValue: null,
            selectedUserIds: null,
            dateOptionValue: optionsDateRange[0],
            valueSet: false,
            startDate: moment().subtract(1, 'years'),
            endDate: moment(),
        }

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.generateExportHref = this.generateExportHref.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState: IPageAdminExportsState) {
        if (prevState.apcCodeOptionValue != this.state.apcCodeOptionValue
            || prevState.plotOptionValue != this.state.plotOptionValue
            || prevState.waterBodyOptionValue != this.state.waterBodyOptionValue
            || prevState.userIdOptionValue != this.state.userIdOptionValue
            || prevState.surnameOptionValue != this.state.surnameOptionValue
        ) {
            this.setState({
                valueSet: this.state.apcCodeOptionValue !== null
                    || this.state.plotOptionValue !== null
                    || this.state.waterBodyOptionValue !== null
                    || this.state.userIdOptionValue !== null
                    || this.state.surnameOptionValue !== null
            });
        }
    }

    onStartDateChange(date) {
        var startDate = moment(date ? date : this.state.startDate)
            .endOf('day');

        var newStartDate = { ...this.state.startDate };

        newStartDate = startDate;

        this.setState({
            startDate: newStartDate
        })
    }

    onEndDateChange(date) {
        var endDate = moment(date ? date : this.state.endDate)
            .endOf('day');

        var newEndDate = { ...this.state.endDate };

        newEndDate = endDate;

        this.setState({
            endDate: newEndDate
        })
    }

    onApcCodeChange(val) {
        this.setState({
            apcCodeOptionValue: val
        });
    }

    onWaterBodyChange(val) {
        this.setState({
            waterBodyOptionValue: val
        });
    }

    onPlotChange(plot) {
        this.setState({
            plotOptionValue: plot
        });
    }

    onUserIdChange(userId) {
        this.setState({
            userIdOptionValue: userId,
            selectedUserIds: userId ? [userId.value] : [],
            userPlotOptionValue: userId ? this.state.userPlotOptionValue : null
        });
    }
    
    onSurnameChange(surname) {
        var ids = [];
        if(surname) {
            var users = this.props.plotMetaInfo.users.filter(user => {
                return user.surname === surname.value;
            });
            users.map(u => ids.push(u.id));
        }
        this.setState({
            surnameOptionValue: surname,
            selectedUserIds: ids,
            userPlotOptionValue: surname ? this.state.userPlotOptionValue : null
        });
    }

    onDateSelectChange(val) {
        this.setState({
            dateOptionValue: val
        });
    }

    onUserSiteChange(val) {
        this.setState({
            userPlotOptionValue: val
        });
    }

    getUserSites(userIds) {
        if(userIds && userIds.length > 0) {
            var res = this.props.plotMetaInfo.userRoles.filter(ur => {
                return userIds.includes(ur.userId);
            });
            var plotIds = [];
            res.map(r => plotIds.push(r.plotId));
            var plots = this.props.plots.filter(plot => {
                return plotIds.indexOf(plot.id) !== -1;
            });
            var names = [];
            plots.map(p => names.push({ value: p.id, label: p.name }));
            return names;

        } else {
            return [];
        }
    }

    generateExportHref() {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminPlotExport();
        request.plotId = this.state.plotOptionValue ? this.state.plotOptionValue.value : 
            this.state.userPlotOptionValue ? this.state.userPlotOptionValue.value : undefined;
        request.userId = this.state.userIdOptionValue ? this.state.userIdOptionValue.value : undefined;
        request.apcCode = this.state.apcCodeOptionValue ? this.state.apcCodeOptionValue.value : undefined;
        request.waterBody = this.state.waterBodyOptionValue ? this.state.waterBodyOptionValue.value : undefined;
        request.surname = this.state.surnameOptionValue ? this.state.surnameOptionValue.value : undefined;
        request.startDate = this.state.dateOptionValue.value == 'CUSTOM' ? this.state.startDate.format('YYYY-MM-DD') : undefined;
        request.endDate = this.state.dateOptionValue.value == 'CUSTOM' ? this.state.endDate.format('YYYY-MM-DD') : undefined;
        return client.createUrlFromDto("GET", request);
    }

    render() {
        const customDateRange = this.state.dateOptionValue && this.state.dateOptionValue.value === 'CUSTOM';
        const exportHref = this.generateExportHref();
        
        const userDetails = this.state.userIdOptionValue || this.state.surnameOptionValue ? true : false;
        const userPlots = <>
            <div className="form-group row mt-2">
            <label className="col-md-2 col col-form-label">User's Site:</label>
            <div className="col-md-4 col">
                <Select
                    isDisabled={this.state.userIdOptionValue == null && this.state.surnameOptionValue == null}
                    options={this.getUserSites(this.state.selectedUserIds)}
                    value={this.state.userPlotOptionValue}
                    onChange={this.onUserSiteChange.bind(this)}
                    isSearchable={true}
                    isClearable={true}
                />
            </div>
            </div>
        </>

        const dateControls = <><div className="form-group row mt-2">
            <label className="col-md-2 col-form-label">From:</label>
            <div className="col-md-4 col">
                <ReactDatetimeClass
                    className={"filter-date-calendar"}
                    onChange={this.onStartDateChange}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={false}
                    inputProps={{
                        placeholder: "DD/MM/YYYY",
                        className: "form-control form-control-date",
                    }}
                    input={true}
                    value={...this.state.startDate}
                />
            </div>
        </div>
            <div className="form-group row mt-2">
                <label className="col-md-2 col-form-label">To:</label>
                <div className="col-md-4 col">
                    <ReactDatetimeClass
                        className={"filter-date-calendar"}
                        onChange={this.onEndDateChange}
                        dateFormat={"DD/MM/YYYY"}
                        timeFormat={false}
                        inputProps={{
                            placeholder: "DD/MM/YYYY",
                            className: "form-control form-control-date",
                        }}
                        input={true}
                        value={...this.state.endDate}
                    />
                </div>
            </div></>

        

        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            <div className="col-12 pb-2 border-bottom">
                <div className="my-3 border d-flex flex-row">
                    <span><i className="fa fa-info-circle p-3" />You can type in the drop down boxes to search. Click the cross on the right or press back space with the box selected to clear.</span>
                </div>
                <div className="form-group row">
                    <label className="col-md-2 col-form-label">APC Code:</label>
                    <div className="col-md-4 col">
                        <PlotMetaInfoSelect
                            disabled={this.state.valueSet && this.state.apcCodeOptionValue == null}
                            plotMetaInfoPropertyKey={'apcCodes'}
                            onChange={this.onApcCodeChange.bind(this)}
                            value={this.state.apcCodeOptionValue}
                        />
                    </div>
                </div>
                <div className="form-group row mt-2">
                    <label className="col-md-2 col-form-label">Waterbody:</label>
                    <div className="col-md-4 col">
                        <PlotMetaInfoSelect
                            disabled={this.state.valueSet && this.state.waterBodyOptionValue == null}
                            plotMetaInfoPropertyKey={'waterBodys'}
                            onChange={this.onWaterBodyChange.bind(this)}
                            value={this.state.waterBodyOptionValue}
                        />
                    </div>
                </div>
                <div className="form-group row mt-2">
                    <label className="col-md-2 col-form-label">Site:</label>
                    <div className="col-md-4 col">
                        <PlotSelect
                            disabled={this.state.valueSet && this.state.plotOptionValue == null}
                            onChange={this.onPlotChange.bind(this)}
                            value={this.state.plotOptionValue}
                        />
                    </div>
                </div>

                <div className="form-group row mt-2">
                    <label className="col-md-2 col-form-label">User ID:</label>
                    <div className="col-md-4 col">
                        <PlotMetaUserInfoSelect
                            disabled={this.state.valueSet && this.state.userIdOptionValue == null}
                            plotMetaInfoPropertyKey={'users.id'}
                            onChange={this.onUserIdChange.bind(this)}
                            value={this.state.userIdOptionValue}
                        />
                    </div>
                </div>
                <div className="form-group row mt-2">
                    <label className="col-md-2 col-form-label">Surname:</label>
                    <div className="col-md-4 col">
                        <PlotMetaUserInfoSelect
                            disabled={this.state.valueSet && this.state.surnameOptionValue == null}
                            plotMetaInfoPropertyKey={'users.surname'}
                            onChange={this.onSurnameChange.bind(this)}
                            value={this.state.surnameOptionValue} 
                        />
                    </div>
                </div>

                {userDetails ? userPlots : null}

                <div className="form-group row mt-2">
                    <label className="col-md-2 col-form-label">Date Range:</label>
                    <div className="col-md-4 col">
                        <Select
                            options={optionsDateRange}
                            value={this.state.dateOptionValue}
                            onChange={this.onDateSelectChange.bind(this)}
                        />
                    </div>
                </div>
                {customDateRange ? dateControls : null}
            </div>
            <div className="col-12 pt-3">
                <a className="btn btn-primary" href={exportHref}>{this.state.valueSet ? 'Export Selected Site(s)' : 'Export All Sites'}</a>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminExportPlotsAllProps): PageAdminExportPlotsPropsMapped => {

    return {
        plotLoading: state.data.plotLoading,
        plotMetaInfo: state.admin.plotMetaInfo,
        plots: state.admin.plots,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminExportPlotsActionsMapped>({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<PageAdminExportPlotsAllProps>(PageAdminExportPlots));